/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- ENGAGEMENT DIVISION : STYLES --------------- ++++++++++ */
export default theme => ({
  engagement: {},
  SelectWrapper: {
    position: 'relative',
    display: 'inline-block',

    '& i': {
      top: pxToEm(26),
      right: pxToEm(17),
      position: 'absolute',
      color: 'rgb(20, 148, 244)',
      zIndex: 100,
      fontSize: pxToEm(14, 17),
    }

  },
  SelectField: {
    background: 'none',
    height: pxToEm(63, 18),
    color: 'rgb(20, 148, 244)',
    fontSize: '1em',
    fontWeight: '500',
    border: '1px solid rgba(178, 193, 230, 0.3)',
    minWidth: '10em',
    width: 'auto',
    padding: '0 3em 0 1em',
    borderRadius: pxToEm(13.5),
    '-webkit-appearance': 'none',
    appearance: 'none',
  }
});
